export const isAxiosErrorResponse = (response) => {
    const toEvaluate = response;
    return toEvaluate.response !== undefined && toEvaluate.response.data !== undefined && toEvaluate.response.data.message !== undefined;
};
